/* wg-chat-trigger.js - Wade Greens
   Three "chat" controls open the chat panel instead of loading /pages/contact.

   WHICH THREE, AND NOTHING ELSE

     1. The desktop header's black utility row, leftmost of the four icons:
            <a href="/pages/contact" aria-label="Contact support">
        (it sits inside a button.modal-toggle the theme wraps around it; the
        anchor is what navigates, so the anchor is what is matched).

     2. The footer's NEED SOME HELP? row, third tile. BOTH of its links:

            <div class="footer-info container">
              <a href="/pages/contact">            <- the icon, no class
                <div class="footer icon"><svg ...><title>Customer Service</title>
              <p class="footer-info">
                <a class="footer-info" href="/pages/contact">ONLINE CHAT</a>

        The first pass only matched the labelled anchor, so the words opened
        the panel and the icon above them still navigated away - which is the
        half of the tile most people aim at. The icon anchor carries no class,
        no aria-label and no text of its own, so there is nothing on the
        element itself to match. What identifies it is the tile it sits in, so
        the test walks up to the nearest .footer-info and reads that.

        .closest() includes the element itself, so the same line covers the
        labelled anchor (its own .footer-info holds "ONLINE CHAT") and the
        icon (its tile holds "Customer Service ONLINE CHAT"). The CONTACT US
        tile next to it is a separate .footer-info.container reading
        "CONTACT US", so it is not caught.

   Fourteen other links on the same page also point at /pages/contact - the
   CONTACT US tile beside it, SUPPORT > Contact, and COMPANY > Contact among
   them - and those must keep going to the contact page. Read live 2026-10-24
   there are 16 links to that page on the homepage; the match below takes
   exactly 3. A plain href test would take all sixteen.

   HOW THE PANEL OPENS. The widget is Shopify Inbox, which renders as
   <shopify-chat> with a shadow root holding button.activator. Read live
   2026-10-23 its element exposes show() / close() as methods and `open` as a
   boolean GETTER - sc.open() throws, which is why show() is used. Clicking
   the activator inside the shadow root does the same thing and is kept as a
   fallback in case the method is renamed.

   IT DEGRADES TO THE LINK. preventDefault is called only AFTER the panel has
   actually been opened. If the widget has not loaded, is blocked, or the
   element has changed shape, openChat() returns false, nothing is prevented
   and the click navigates to /pages/contact exactly as it does today. The
   href is never removed, so this is also what happens with JS off and what a
   middle-click or cmd-click still does.

   CAPTURE PHASE, AND WHY. The header anchor is wrapped in a modal-toggle
   button that has its own bubble-phase handler. Listening at capture on
   document means this runs before that handler and before the default
   navigation, from one listener, and keeps working for markup that is
   re-rendered later (the footer is static, but the header row is moved
   around by wg-sticky-ab.js).
*/

(function () {
  'use strict';

  function openChat() {
    var sc = document.querySelector('shopify-chat');
    if (!sc) return false;

    if (typeof sc.show === 'function') {
      try {
        sc.show();
        return true;
      } catch (e) { /* fall through to the activator */ }
    }

    var root = sc.shadowRoot;
    if (!root) return false;
    var activator = root.querySelector('button.activator, button[part="activator"]');
    if (!activator) return false;
    activator.click();
    return true;
  }

  function isChatTrigger(a) {
    var href = a.getAttribute('href') || '';
    if (href.indexOf('/pages/contact') === -1) return false;

    /* header utility row */
    if ((a.getAttribute('aria-label') || '').toLowerCase() === 'contact support') return true;

    /* footer NEED SOME HELP? tile - the label and the icon above it */
    var tile = a.closest ? a.closest('.footer-info') : null;
    if (tile && (tile.textContent || '').toLowerCase().indexOf('online chat') > -1) return true;

    return false;
  }

  document.addEventListener('click', function (e) {
    /* leave new-tab and middle-click intents alone */
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var a = e.target && e.target.closest ? e.target.closest('a[href*="/pages/contact"]') : null;
    if (!a || !isChatTrigger(a)) return;

    if (openChat()) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
})();
